module.exports = __webpack_public_path__ + "static/media/rss25.13c4042b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/social-icons/rss25.svg
// module id = 550
// module chunks = 0